export default __webpack_public_path__ + "static/media/buster_klein_76.fe3d8707.jpg";